import en from "./translations/en"
import nb from "./translations/nb"
import nn from "./translations/nn"

export const messages: { [lang: string]: { [id: string]: string } } = {
  nb,
  nn,
  en,
  "nb-NO": nb,
  "nn-NO": nn,
  "en-GB": en,
  "en-US": en,
}
